import { controllers } from "../../Controllers/Controllers";
import { UPDATE } from "../../DataTypes/UPDATE";
import { LangItem } from "./LangItem";
import { UpdateComponent } from "./UpdateComponent";

type authItemProps = {
    children: any;
    statusMessage?: string;
}

class AuthItem extends UpdateComponent {
    props: authItemProps;
    constructor(props:authItemProps){
        super(props)
        this.type = UPDATE.AUTH
        this.props = props
    }

    render(){
        const { statusMessage } = this.props
        return controllers().auth.userToken ? this.props.children 
        : (statusMessage!==undefined ? <div className="not-auth-message"><div className="not-auth-message-box"><LangItem for={statusMessage}/></div></div> : null)
    }
}

export { AuthItem }